import Vue from 'vue'
import Router from 'vue-router'

import Auth from '@/common/auth'

import Template from '@/template/index'
// import Home from '@/views/home'
import Authorized from '@/views/authorized'
import TrocarEscola from '@/views/trocarescola'
import AcessoNegado from '@/views/acessonegado'
import Cadastro from '@/views/cadastro'
import NotFound from '@/views/404'

import routersgenerated from './generated'

Vue.use(Router)

let childrens = routersgenerated.concat([])

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/admin',
      redirect: '/admin/acaocomercial',
      component: Template,
      meta: { requiresAuth: true },
      children: childrens
    },
    {
      path: '/cadastro',
      component: Cadastro,
      meta: { requiresAuth: false }
    },
    {
      path: '/',
      component: Cadastro,
      redirect: '/cadastro',
      meta: { requiresAuth: false }
    },
    {
      path: '/cadastro/:id',
      component: Cadastro,
      meta: { requiresAuth: false }
    },
    {
      path: '/authorized',
      name: 'authorized',
      component: Authorized
    },
    {
      path: '/trocarescola',
      name: 'trocarescola',
      component: TrocarEscola
    },
    {
      path: '/acessonegado',
      name: 'acessonegado',
      component: AcessoNegado
    },
    {
      path: '*',
      beforeEnter: (to, from, next) => {
        next('/404')
      }
    },
    {
      path: '/404',
      name: '404',
      component: NotFound
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!Auth.logged()) {
      Auth.login(true)
      return
    }

    if (!Auth.canAccess(to.path)) {
      next('/acessonegado')
      return
    }
  }
  next()
})

export default router
